
/*----------------------
       MEDIA TEXT
---------------------- */
MediaText = {
    init: function () {
        if ($(".swiper-media-text").length) {
            var swiper = new Swiper(".swiper-media-text", {
                slidesPerView: 1,
                navigation: {
                    nextEl: ".section-media-text__media .btn--next",
                    prevEl: ".section-media-text__media .btn--prev",
                },
                pagination: {
                    el: '.swiper-pagination',
                },
            });
        }
    }
};

$(document).ready(function () {
    MediaText.init();
});

